import EventIcon from "@material-ui/icons/Event";
import React from "react";
import { object, func } from "prop-types";

import Icon from "@components/shared/Icons/Icon";

const DatePickerTextField = ({ inputRef, onClick, ...props }) => {
  return (
    <div
      className="flex items-center border-2 border-greyLight rounded-sm text-base tracking-wide relative"
      onClick={onClick}
    >
      <input
        className="bg-white border-0 text-sm font-citroen w-full outline-0 p-2 disabled:bg-greyLight"
        readOnly
        type="text"
        ref={inputRef}
        {...props}
      />
      <Icon
        className="absolute right-2 top-1/2 -translate-y-1/2 size-5 text-greyLight pointer-events-none"
        icon={<EventIcon />}
      />
    </div>
  );
};

DatePickerTextField.propTypes = {
  inputRef: object.isRequired,
  onClick: func.isRequired,
};

export default DatePickerTextField;
